export var buttonTypeLabel = {
  scrollTotop: {
    type: 'scrollTotop',
    label: 'Back to top'
  }
};